module.exports = __webpack_public_path__ + "fonts/Roboto-500-cyrillic41.f92ee38.woff2";